import { create } from "zustand";
import { httpRequest } from "../utils/httpRequest";

const initialState = {
  loading: false,
  success: false,
  error: false,
  data: null,
  errorData: null,
};

const request = (props, option) =>
  create((set, get) => ({
    ...initialState,
    execute: (p) => {
      if (props.method === "GET" && !p?.force && Boolean(get().data)) {
        return;
      }
      set({ ...initialState, loading: true });
      httpRequest({
        ...props,
        data: { ...props?.data, ...p?.data },
        params: { ...props?.params, ...p?.params },
      })
        .then((res) => {
          set({ ...initialState, success: true, data: res.data });
          p?.onSuccess?.(res);
          option?.onSuccess?.(res);
          // console.log("%cSuccess request: ", "color:green;", res.data);
        })
        .catch((err) => {
          set({ ...initialState, error: true, errorData: err });
          p?.onError?.(err);
          option?.onError?.(err);
          // console.log("%Error request: ", "color:green;", err);
          if (
            // !p?.onError &&
            // !option?.onError &&
            typeof err?.response?.data === "string"
          ) {
            // message.error(err?.response?.data);
          }
        })
        .finally(() => {
          p?.onFinal?.();
          option?.onFinal?.();
        });
      // }
    },
    clean: () => {
      set(initialState);
    },
  }));

const requestList = (props, option) =>
  create((set, get) => ({
    ...initialState,
    execute: (p) => {
      if (props.method === "GET" && !p?.force && Boolean(get().data)) {
        return;
      }
      set({ ...initialState, data: get().data, loading: true });
      httpRequest({
        ...props,
        data: { ...props?.data, ...p?.data },
        params: { ...props?.params, ...p?.params },
      })
        .then((res) => {
          set({ ...initialState, success: true, data: res.data });
          p?.onSuccess?.(res);
          option?.onSuccess?.(res);
          // console.log("%cSuccess request: ", "color:green;", res.data);
        })
        .catch((err) => {
          set({ ...initialState, error: true, errorData: err });
          p?.onError?.(err);
          option?.onError?.(err);
          // console.log("%Error request: ", "color:green;", err);
        })
        .finally(() => {
          p?.onFinal?.();
          option?.onFinal?.();
        });
      // }
    },
    clean: () => {
      set(initialState);
    },
  }));

export const useRoadSigns = requestList({
  method: "GET",
  path: "road-signs",
});

export const usePdfRoadSigns = requestList({
  method: "POST",
  path: "road-signs/make-pdf",
});

export const useAppList = requestList({
  method: "GET",
  path: "app",
});

export const useAppPost = request({
  method: "POST",
  path: "app",
});

export const useAppPut = request({
  method: "PUT",
  path: "app",
});

export const useAppDel = request({
  method: "DELETE",
  path: "app",
});

export const useCategoryList = requestList({
  method: "GET",
  path: "category",
});

export const useEditCategory = request({
  method: "PUT",
  path: "category",
});

export const useEditFlashcard = request({
  method: "PUT",
  path: "flashcard",
});

export const useGenerateAudio = request({
  method: "POST",
  path: "audio/generate",
});
